import { parkPath, trailPath } from "./routes";

export const absoluteAppUrl = (path) => {
  if (typeof window === "undefined") return path;
  return new URL(path, window.location.origin).toString();
};

export const whatsappShareUrl = ({ title, text, url }) => {
  const body = [title, text, url].filter(Boolean).join("\n");
  return `https://wa.me/?text=${encodeURIComponent(body)}`;
};

export const facebookShareUrl = (url) =>
  `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

export async function nativeShare({ title, text, url }) {
  if (typeof navigator === "undefined" || typeof navigator.share !== "function") return false;
  try {
    await navigator.share({ title, text, url });
    return true;
  } catch (error) {
    if (error?.name === "AbortError") return true;
    return false;
  }
}

export async function copyShareLink(url) {
  if (typeof navigator === "undefined" || !navigator.clipboard?.writeText) return false;
  await navigator.clipboard.writeText(url);
  return true;
}

export const parkSharePayload = (park) => ({
  title: park?.name || "Bikeparks Finder destination",
  text: park?.city ? `${park.name} · ${park.city}` : park?.name,
  url: absoluteAppUrl(parkPath(park)),
  analytics: {
    content_type: "park",
    item_id: park?.id ? String(park.id) : "",
    item_name: park?.name || "",
  },
});

export const trailSharePayload = (trail) => ({
  title: trail?.name || "Bikeparks Finder trail",
  text: trail?.park?.name ? `${trail.name} · ${trail.park.name}` : trail?.name,
  url: absoluteAppUrl(trailPath(trail)),
  analytics: {
    content_type: "trail",
    item_id: trail?.id ? String(trail.id) : "",
    item_name: trail?.name || "",
  },
});

export const eventSharePayload = (event) => ({
  title: event?.title || "Bikeparks Finder event",
  text: [event?.venueName, event?.city].filter(Boolean).join(", "),
  url: absoluteAppUrl(`/events?event=${encodeURIComponent(event?.id || "")}`),
  analytics: {
    content_type: "event",
    item_id: event?.id ? String(event.id) : "",
    item_name: event?.title || "",
  },
});

export const parkPlanningMessage = (park) => {
  const url = absoluteAppUrl(parkPath(park));
  const location = [park?.city, park?.country].filter(Boolean).join(", ");
  const lines = [
    `🚵 Plan za vožnju: ${park?.name || "Bike park"}`,
    location || null,
    "",
    "Ko ide? Dogovorimo datum i prevoz ovdje 👇",
    url,
  ].filter((line) => line !== null);
  return lines.join("\n");
};

export const parkPlanningWhatsAppUrl = (park) =>
  `https://wa.me/?text=${encodeURIComponent(parkPlanningMessage(park))}`;
